window.TeeStickyGalleryAPI = window.TeeStickyGalleryAPI || {
  isDisabled: false,
  disable: function() {
    this.isDisabled = true;
    if (typeof this._cleanup === 'function') this._cleanup();
    console.log("TeeStickyGallery disabled");
  },
  enable: function() {
    this.isDisabled = false;
    if (typeof this._check === 'function') this._check();
    console.log("TeeStickyGallery enabled");
  }
};

document.addEventListener("DOMContentLoaded", () => {

  /* ======================================================
   * DOUBLE TAP ZOOM
   * ====================================================== */
  function bindDoubleTapZoom(target, panzoom) {
    let lastTap = 0;
    let startX = 0;
    let startY = 0;
    let moved = false;

  const MOVE_THRESHOLD = 10; // px – small finger movement tolerance

    target.addEventListener(
      "touchstart",
      (e) => {
        if (!panzoom) return;
        if (e.touches.length !== 1) return;

        const touch = e.touches[0];
        startX = touch.clientX;
        startY = touch.clientY;
        moved = false;
      },
      { passive: true }
    );

    target.addEventListener(
      "touchmove",
      (e) => {
        if (!panzoom) return;
        if (!e.touches || e.touches.length !== 1) return;

        const touch = e.touches[0];
        const dx = Math.abs(touch.clientX - startX);
        const dy = Math.abs(touch.clientY - startY);

        if (dx > MOVE_THRESHOLD || dy > MOVE_THRESHOLD) {
        moved = true; // this gesture is a drag
        }
      },
      { passive: true }
    );

    target.addEventListener(
      "touchend",
      (e) => {
        if (!panzoom) return;

      // If this was a drag → do NOT count as tap
        if (moved) {
        lastTap = 0; // reset tap chain
          return;
        }

        const now = Date.now();
        const tapInterval = now - lastTap;

        const touch = e.changedTouches[0];
        const point = {
          clientX: touch.clientX,
          clientY: touch.clientY,
        };

        if (tapInterval < 300 && tapInterval > 50) {
          e.preventDefault();

          const scale = panzoom.getScale();

          if (scale <= 1.05) {
            panzoom.zoomToPoint(2.2, point, { animate: true });
          } else {
            panzoom.reset({ animate: true });
          }

        lastTap = 0; // consume double tap
          return;
        }

        lastTap = now;
      },
      { passive: false }
    );
  }

  /* ======================================================
   * PANZOOM LOADER
   * ====================================================== */
  function loadPanzoom(cb) {
    if (window.Panzoom) return cb();

    const script = document.createElement("script");
    script.src =
      "https://unpkg.com/@panzoom/panzoom@4.6.1/dist/panzoom.min.js";
    script.onload = cb;
    document.head.appendChild(script);
  }

  let panzoomInstance = null;
  let panzoomInited = false;

  /* ======================================================
   * INIT PANZOOM
   * ====================================================== */
  function initPanzoomIfNeeded() {
    if (panzoomInited) return;

    const track = document.querySelector(".tee-slider__track");
    const content = document.querySelector(".tee-gallery-content");
    if (!track || !content) return;

    loadPanzoom(() => {
      panzoomInstance = Panzoom(track, {
        maxScale: 4,
        minScale: 1,
        startScale: 1,

        contain: "outside",
        panOnlyWhenZoomed: true,

        touchAction: "none",
        cursor: "move",

        animate: true,
        duration: 200,
        easing: "ease-out",
      });

      panzoomInited = true;

      injectPanzoomControls(content);
      bindDoubleTapZoom(track.parentElement, panzoomInstance);

      // Debug helper
      window._panzoom = panzoomInstance;
    });
  }

  /* ======================================================
   * PANZOOM UI CONTROLS
   * ====================================================== */
  function injectPanzoomControls(container) {
    if (container.querySelector(".pz-controls")) return;

    const controls = document.createElement("div");
    controls.className = "pz-controls";
    controls.innerHTML = `
      <div class="pz-btn pz-zoom-in">+</div>
      <div class="pz-btn pz-zoom-out">−</div>
    `;

    container.appendChild(controls);

    controls.querySelector(".pz-zoom-in").onclick = zoomIn;
    controls.querySelector(".pz-zoom-out").onclick = zoomOut;
  }

  function zoomIn() {
    if (!panzoomInstance) return;
    panzoomInstance.zoomIn({ animate: true });
  }

  function zoomOut() {
    if (!panzoomInstance) return;

    const scale = panzoomInstance.getScale();

    // Reset when near base scale
    if (scale <= 1.15) {
      panzoomInstance.reset({ animate: true });
      return;
    }

    panzoomInstance.zoomOut({ animate: true });
  }

  function resetPanzoom() {
    if (!panzoomInstance) return;
    if (panzoomInited) panzoomInited = false;
    panzoomInstance.reset({ animate: false });
  }

  /* ======================================================
   * STICKY GALLERY
   * ====================================================== */
  const fixedLivePreview = () => {
    const galleryWrapperSelector = ".product__images";
    const $gallery = document.querySelector(galleryWrapperSelector);
    if (!$gallery) return;

    /* ---------- Sticky cleanup ---------- */
    let hasScrolledFormBelowStickyGallery = false;

    function cleanupSticky() {
      document.body.classList.remove(
        "gallery--sticky",
        "gallery--sticky--leaving"
      );

      $gallery.style.removeProperty("height");
      $gallery.style.removeProperty("display");
      
      const galleryContent = document.querySelector(".tee-gallery-content");
      if (galleryContent) {
        galleryContent.style.removeProperty("height");
      }
      document.documentElement.style.removeProperty("--sticky-gallery-height");

      // Fully reset zoom when leaving sticky
      resetPanzoom();

      isSticky = false;
      isAnimating = false;

      window.dispatchEvent(new Event("resize"));
    }

    // Expose internal methods to the global API
    window.TeeStickyGalleryAPI._cleanup = cleanupSticky;
    window.TeeStickyGalleryAPI._check = () => {
      if (typeof onScroll === 'function') onScroll();
    };

    /* ---------- Inject CSS ---------- */
    const style = document.createElement("style");
    style.innerHTML = `
      @-webkit-keyframes slideInDown {
        0% {
          -webkit-transform: translate3d(0,-100%,0);
          transform: translate3d(0,-100%,0);
          visibility: visible;
        }

        to {
          -webkit-transform: translateZ(0);
          transform: translateZ(0);
        }
      }

      @keyframes slideInDown {
        0% {
          -webkit-transform: translate3d(0,-100%,0);
          transform: translate3d(0,-100%,0);
          visibility: visible;
        }

        to {
          -webkit-transform: translateZ(0);
          transform: translateZ(0);
        }
      }

      @-webkit-keyframes slideOutUp {
          0% {
              -webkit-transform: translateZ(0);
              transform: translateZ(0)
          }

          to {
              -webkit-transform: translate3d(0,-100%,0);
              transform: translate3d(0,-100%,0);
              visibility: hidden
          }
      }

      @keyframes slideOutUp {
          0% {
              -webkit-transform: translateZ(0);
              transform: translateZ(0)
          }

          to {
              -webkit-transform: translate3d(0,-100%,0);
              transform: translate3d(0,-100%,0);
              visibility: hidden
          }
      }

      .gallery--sticky--leaving ${galleryWrapperSelector} .tee-gallery-content {
          -webkit-animation-duration: .2s !important;
          animation-duration: .2s !important;
          -webkit-animation-duration: .2s !important;
          animation-duration: .2s !important;
          -webkit-animation-name: slideOutUp !important;
          animation-name: slideOutUp !important;
      }

      ${galleryWrapperSelector} .tee-gallery-content {
        -webkit-animation-duration: .4s !important;
        animation-duration: .4s !important;
        -webkit-animation-duration: .4s !important;
        animation-duration: .4s !important;
        -webkit-animation-fill-mode: both;
        animation-fill-mode: both;
        -webkit-animation-delay: 0;
        animation-delay: 0;
      }

      .gallery--sticky ${galleryWrapperSelector} .tee-gallery-content {  
        -webkit-animation-name: slideInDown;
        animation-name: slideInDown;
      }

      .teeinblue-item.teeinblue-item--product {
        z-index: 999;
      }

      .gallery--sticky:not(.gallery--sticky--hide) ${galleryWrapperSelector} .tee-gallery-content {
        background: #fff;
        box-shadow: 0 2px 5px 3px rgba(0, 0, 0, .15);
        display: flex;
        justify-content: center;
        align-items: flex-start;
        left: 0;
        position: fixed;
        top: 0;
        width: 100vw;
        height: var(--sticky-gallery-height, auto) !important;
        overflow: hidden;
        z-index: 999;
      }

      .gallery--sticky:not(.gallery--sticky--hide) ${galleryWrapperSelector} .tee-gallery {
        width: 100%;
        transform: scale(0.65);
        transform-origin: top center;
        flex-shrink: 0;
      }

      .gallery--sticky:not(.gallery--sticky--hide) ${galleryWrapperSelector} .tee-slider__inner {
        overflow: visible !important;
      }

      .gallery--sticky:not(.gallery--sticky--hide) ${galleryWrapperSelector} .tee-thumbnails,
      .gallery--sticky:not(.gallery--sticky--hide) ${galleryWrapperSelector} .tee-slider__dots {
        display: none;
      }

      .gallery--sticky:not(.gallery--sticky--hide) .gallery--close-button {
        display: block;
      }

      .gallery--sticky.gallery--sticky--hide .sticky-gallery-button {
        display: block;
      }

      .sticky-gallery-button {
        background-color: #fff;
        background-image: url('data:image/svg+xml;utf8,<svg version="1.1" id="Layer_2_1_" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve"><g><path d="M114.5,79.1C95,79.1,79.1,95,79.1,114.5v283c0,19.5,15.8,35.4,35.4,35.4h283c19.5,0,35.4-15.8,35.4-35.4v-283 c0-19.5-15.8-35.4-35.4-35.4H114.5z M114.5,409.3c-6.5,0-11.8-5.3-11.8-11.8V308l94.3-94.3l195.6,195.6H114.5z M409.3,392.7 L331.6,315l30.5-30.5l47.2,47.2V392.7z M409.3,114.5v183.8l-38.8-38.9c-4.6-4.6-12.1-4.7-16.7-0.1c0,0,0,0-0.1,0.1L315,298.3 L205.4,188.7c-4.6-4.6-12.1-4.7-16.7-0.1c0,0,0,0-0.1,0.1l-86,86.1V114.5c0-6.5,5.3-11.8,11.8-11.8h283 C404,102.7,409.3,108,409.3,114.5z"/><path d="M326.7,138.1c-26,0-47.2,21.1-47.2,47.2s21.1,47.2,47.2,47.2s47.2-21.1,47.2-47.2S352.8,138.1,326.7,138.1z M326.7,208.8 c-13,0-23.6-10.6-23.6-23.6s10.6-23.6,23.6-23.6s23.6,10.6,23.6,23.6S339.8,208.8,326.7,208.8z"/><path d="M23.7,35c0,0,0.1-4.9,3.3-7.9c3.5-3.4,8.1-3.5,8.1-3.5l89.6,0c0-19.2,0-23.6,0-23.6L34.9,0C15.6,0,0,15.6,0,34.9l0,89.8 l23.7,0V35z"/><path d="M484.9,26.9c3.4,3.5,3.5,8.1,3.5,8.1l0,89.6c19.2,0,23.6,0,23.6,0l0-89.8C512,15.6,496.4,0,477.1,0l-89.8,0l0,23.7H477 C477,23.7,482,23.8,484.9,26.9z"/><path d="M488.3,477c0,0-0.1,4.9-3.3,7.9c-3.5,3.4-8.1,3.5-8.1,3.5l-89.6,0c0,19.2,0,23.6,0,23.6l89.8,0c19.2,0,34.8-15.6,34.8-34.8 l0-89.8l-23.7,0V477z"/><path d="M27.1,485.1c-3.4-3.5-3.5-8.1-3.5-8.1l0-89.6c-19.2,0-23.6,0-23.6,0l0,89.8C0,496.4,15.6,512,34.9,512l89.8,0l0-23.7H35 C35,488.3,30,488.2,27.1,485.1z"/></g></svg>');
        background-position: center;
        background-repeat: no-repeat;
        background-size: 20px 20px;
        border-radius: 50%;
        box-shadow: 0px 0px 5px;
        display: none;
        height: 40px;
        position: fixed;
        right: 20px;
        top: 100px;
        width: 40px;
        z-index: 999;
      }

      .gallery--close-button {
        background-image: url('data:image/svg+xml;utf8,<svg height="329pt" viewBox="0 0 329.26933 329" width="329pt" xmlns="http://www.w3.org/2000/svg"><path d="m194.800781 164.769531 128.210938-128.214843c8.34375-8.339844 8.34375-21.824219 0-30.164063-8.339844-8.339844-21.824219-8.339844-30.164063 0l-128.214844 128.214844-128.210937-128.214844c-8.34375-8.339844-21.824219-8.339844-30.164063 0-8.34375 8.339844-8.34375 21.824219 0 30.164063l128.210938 128.214843-128.210938 128.214844c-8.34375 8.339844-8.34375 21.824219 0 30.164063 4.15625 4.160156 9.621094 6.25 15.082032 6.25 5.460937 0 10.921875-2.089844 15.082031-6.25l128.210937-128.214844 128.214844 128.214844c4.160156 4.160156 9.621094 6.25 15.082032 6.25 5.460937 0 10.921874-2.089844 15.082031-6.25 8.34375-8.339844 8.34375-21.824219 0-30.164063zm0 0"/></svg>');
        background-position: center;
        background-repeat: no-repeat;
        background-size: 16px 16px;
        display: none;
        height: 16px;
        opacity: 0.5;
        position: absolute;
        right: 20px;
        top: 20px;
        width: 16px;
      }

      .tee-slider__track {
        transition: transform 0.05s ease-out !important; 
      }

      body:not(.gallery--sticky) .tee-slider__track {
        transform: none !important;
      }

      #tee-gallery .tee-slider {
        width: 100% !important;
        overflow: visible;
      }

      body:not(.gallery--sticky) .pz-controls {
        display: none;
      }

      .gallery--sticky:not(.gallery--sticky--hide) .pz-controls {
        position: absolute;
        bottom: 8px;
        right: 10px;
        display: flex;
        flex-direction: column;
        background: #fff;
        border: 1px solid #ddd;
        border-radius: 4px;
        overflow: hidden;
      }

      .gallery--sticky:not(.gallery--sticky--hide) .pz-btn {
        background: #fff;
        border: none;
        width: 32px;
        height: 32px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        font-size: 20px;
        position: relative;
      }

      .gallery--sticky:not(.gallery--sticky--hide) .pz-btn:first-child:after {
        content: "";
        position: absolute;
        bottom: 0;
        left: 2px;
        right: 2px;
        height: 1px;
        background: #ddd;
        border: 0 solid #e5e7eb;
      }

      .gallery--sticky:not(.gallery--sticky--hide) .pz-btn span {
        line-height: 1;
        color: #000000;
        opacity: 0.6;
      }
    `;
    document.head.appendChild(style);

    /* ---------- Sticky state ---------- */
    let hasStickyButton = false;
    let hasCloseButton = false;
    let isSticky = false;
    let isAnimating = false;
    let lastScrollY = window.scrollY;
    let scrollUpDistance = 0;

    const STATE = {
      NORMAL: "normal",
      STICKY: "sticky",
      LEAVING: "leaving",
    };

    let galleryState = STATE.NORMAL;
    let originalContentHeight = 0;

    const updateStickyHeightSafely = () => {
      const slider = document.querySelector(".tee-slider");
      if (slider && slider.offsetHeight > 50) {
        document.documentElement.style.setProperty("--sticky-gallery-height", `${slider.offsetHeight * 0.65}px`);
      }
    };

    let mutationTimer = null;
    const observer = new MutationObserver(() => {
      if (window.TeeStickyGalleryAPI.isDisabled) return;
      
      if (galleryState === STATE.STICKY) {
        updateStickyHeightSafely();
        // Check if TIB wiped out panzoom controls
        if (!document.querySelector(".pz-controls")) {
          panzoomInited = false;
          initPanzoomIfNeeded();
        }
      }
      clearTimeout(mutationTimer);
      mutationTimer = setTimeout(onScroll, 100);
    });
    observer.observe($gallery, { 
      childList: true, 
      subtree: true,
      attributes: true,
      attributeFilter: ['style', 'class']
    });

    window.addEventListener("resize", () => {
      if (window.TeeStickyGalleryAPI.isDisabled) return;
      if (galleryState === STATE.STICKY) {
        updateStickyHeightSafely();
      }
    });

    /* ---------- Scroll handler ---------- */
    const onScroll = () => {
      if (window.TeeStickyGalleryAPI.isDisabled) return;
      if (isAnimating) return;

      const currentScrollY = window.scrollY;
      const deltaY = currentScrollY - lastScrollY;
      const isScrollingUp = deltaY < 0;
      const isScrollingDown = deltaY > 0;

      if (deltaY < 0) scrollUpDistance += Math.abs(deltaY);
      else scrollUpDistance = 0;

      lastScrollY = currentScrollY;

      const $teeGallery = document.querySelector(
        `${galleryWrapperSelector} #tee-gallery`
      );
      if (!$teeGallery) return;

      /* ---------- Buttons injection ---------- */
      if (!hasStickyButton) {
        const stickyButton = document.createElement("div");
        stickyButton.className = "sticky-gallery-button";
        stickyButton.onclick = (e) => {
          e.preventDefault();
          document.body.classList.remove("gallery--sticky--hide");

          $gallery.style.height = `${originalContentHeight + 12}px`;
          $gallery.style.display = "block";
        };
        document.body.appendChild(stickyButton);
        hasStickyButton = true;
      }

      if (!hasCloseButton) {
        const closeButton = document.createElement("div");
        closeButton.className = "gallery--close-button";
        closeButton.onclick = (e) => {
          e.preventDefault();
          document.body.classList.add("gallery--sticky--hide");
          $gallery.style.removeProperty("height");
          $gallery.style.removeProperty("display");
        };
        $teeGallery.appendChild(closeButton);
        hasCloseButton = true;
      }

      /* ---------- Geometry ---------- */
      const galleryBottom = $gallery.getBoundingClientRect().bottom;
      const formBottom = document
        .getElementById("tee-artwork-form")
        .getBoundingClientRect().bottom;

      const contentHeight = document.querySelector(
        ".tee-gallery-content"
      ).offsetHeight;

      const ENTER_POINT = -80;
      const EXIT_POINT = -40;

      const canEnterSticky =
        galleryState === STATE.NORMAL &&
        galleryBottom < ENTER_POINT &&
        formBottom > contentHeight;

      const shouldLeaveUp =
        galleryState === STATE.STICKY &&
        isScrollingUp &&
        galleryBottom > EXIT_POINT;

      const shouldLeaveDown =
        galleryState === STATE.STICKY &&
        isScrollingDown &&
        formBottom < contentHeight;

      /* ---------- ENTER ---------- */
      if (canEnterSticky) {
        galleryState = STATE.STICKY;
        originalContentHeight = contentHeight;
        
        // Calculate the target height before adding the sticky class
        // Since thumbnails are hidden in sticky mode, we only scale the slider's height
        const slider = document.querySelector(".tee-slider");
        const targetStickyHeight = slider ? (slider.offsetHeight * 0.65) : (contentHeight * 0.65);

        document.documentElement.style.setProperty("--sticky-gallery-height", `${targetStickyHeight}px`);
        document.body.classList.add("gallery--sticky");

        $gallery.style.height = `${originalContentHeight + 12}px`;
        $gallery.style.display = "block";

        const scrollFormBelowStickyModal = () => {
          if (hasScrolledFormBelowStickyGallery) return;
          const formEl = document.getElementById("teeFormInputs") || document.getElementById("tee-artwork-form");
          const galleryEl = document.querySelector(".tee-gallery-content");
          const FORM_GAP_PX = 8;
          if (!formEl || !galleryEl) return;
          hasScrolledFormBelowStickyGallery = true;
          const stickyBarHeight = galleryEl ? galleryEl.offsetHeight : contentHeight;
          // Distance from viewport top to where we want the form's top edge (below fixed bar).
          const desiredTop = stickyBarHeight + FORM_GAP_PX;
          const formTop = formEl.getBoundingClientRect().top;
          // scrollBy({ top: d }) with d > 0 scrolls down → getBoundingClientRect().top decreases by d.
          // Want formTop - d = desiredTop  ⇒  d = formTop - desiredTop (not desiredTop - formTop).
          const scrollDelta = formTop - desiredTop;
          if (Math.abs(scrollDelta) > 0.5) {
            window.scrollBy({
              top: scrollDelta,
              left: 0,
              behavior: "auto",
            });
          }
        };
        requestAnimationFrame(() => {
          requestAnimationFrame(scrollFormBelowStickyModal);
        });

        // Enable panzoom ONLY when sticky
        initPanzoomIfNeeded();
        return;
      }

      /* ---------- LEAVE ---------- */
      if (shouldLeaveUp || shouldLeaveDown) {
        galleryState = STATE.LEAVING;
        document.body.classList.add("gallery--sticky--leaving");

        const galleryContent = document.querySelector(".tee-gallery-content");
        const onAnimEnd = () => {
          cleanupSticky();
          galleryState = STATE.NORMAL;
          galleryContent.removeEventListener("animationend", onAnimEnd);
        };

        galleryContent.addEventListener("animationend", onAnimEnd);
      }
    };

    window.addEventListener("scroll", onScroll);
    window.addEventListener("DOMMouseScroll", onScroll);
  };

  /* ======================================================
   * MOBILE PORTRAIT ONLY
   * ====================================================== */
  const w = window.innerWidth;
  const h = window.innerHeight;

  if (h / w > 1.5 && w < 768) {
    setTimeout(fixedLivePreview, 2000);
  }
});